import { useQuery } from '@apollo/client';
import { GET_PAGE } from 'api/pages/queries';
import { PageQuery, PageQueryVariables, PageIdType } from 'types';
import { setDataFromTreeToCache } from 'lib/apolloClient';
import { useGetCurrentLocale } from 'hooks';
import { SeoHead, PageWrapper } from 'layouts';
import { Home } from 'components';

const HomePage = () => {
  const currentLocale = useGetCurrentLocale();

  const { data: pageData } = useQuery<PageQuery, PageQueryVariables>(GET_PAGE, {
    variables: {
      id: '/',
      idType: PageIdType.Uri,
    },
    errorPolicy: 'all',
  });

  const currentPageLocale = pageData?.page?.locale?.locale;

  // find translation is such way because for SEO purpose we need to keep locale as "fr" (from next.config.js) instead of "fr_FR"
  const data =
    currentLocale === currentPageLocale
      ? pageData?.page
      : pageData?.page?.translated?.find(
          (item) => item?.locale?.locale === currentLocale
        ) || pageData?.page;

  return (
    <PageWrapper headerColor="white">
      <SeoHead seoHead={data?.seo?.fullHead} />
      {data && <Home data={data} />}
    </PageWrapper>
  );
};

export const getStaticProps = setDataFromTreeToCache(HomePage);

export default HomePage;
